<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="On-Sale"></app-breadcrumb>

        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mb-n2">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- count -->
        <div class="row">
            <div class="col-md-9 col-12">
                <p><span class="h3 md-small-text">Discounted Sales</span> <br>(sell your items faster at a discounted price for a period of time)</p>
            </div>
            <div class="col-md-3 col-12 text-right">
                <button @click="newSalesRule = true" class="btn btn-warning form-control">
                    <i class="fas fa-plus-circle"></i> New Sale
                </button>
            </div>
        </div>
        <!-- sales -->
        <div class="row">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-striped mt-2">
                        <thead class="bg-silver">
                            <tr>
                                <th>S/N</th>
                                <th>Sales Rule</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody v-if="myRules">
                            <tr @click="viewSale = true" v-for="(rule, i) in myRules" :key="i">
                                <td>{{i+1}}.</td>
                                <td>
                                    <router-link :to="{ name: 'saleId', params: { id: rule._id} }">
                                        {{rule.name | capitalize}} <i class="far fa-share-square"></i>
                                    </router-link>
                                </td>
                                <td>{{rule.description.substring(0, 20)}}...</td>
                                <td>
                                    <strong v-if="rule.applied" class="text-dark-green">Active</strong>
                                    <strong v-else class="text-danger">Inactive</strong>
                                </td>
                                <td>
                                    <router-link v-if="rule.applied" :to="{ name: 'saleId', params: { id: rule._id} }" class="btn btn-dark-green btn-sm">
                                        Manage Rule
                                    </router-link>
                                    <template v-else>
                                        <button @click="applyRuleFxn(rule._id)" class="loadn btn btn-dark btn-sm mr-2">Apply</button>
                                        <button @click="deleteRuleFxn(rule._id)" class="loadn btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></button>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- new sales rule -->
        <app-new-sale v-if="newSalesRule"></app-new-sale>
        
        <!-- apply sales rule -->
        <app-apply-sale v-if="applySalesRule && selectedRule" :theRule="selectedRule"></app-apply-sale>
        
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

import Breadcrumb from '../shared/Breadcrumb.vue'
import GhostMode from '@/components/general/shared/GhostMode.vue'
import LayoutShop from '@/layouts/Shop.vue'
import NewSale from './salesParts/NewSale.vue'
import ApplySale from './salesParts/ApplySale.vue'

export default {
    name: "Sales",
    data() {
        return {
            msg: '',
            color: 'danger',
            applySalesRule: false,
            newSalesRule: false,
            selectedRule: false
        }
    },
    methods: {
        ...mapActions(['fetchSalesRules', 'deleteSalesRule']),
        applyRuleFxn(theRuleId) {
            if(this.myRules){
                let ruleDetails = this.myRules.find(rule => rule._id == theRuleId)
                this.selectedRule = {
                    id: ruleDetails._id,
                    name: ruleDetails.name
                }
                this.applySalesRule = true
            }
        },
        deleteRuleFxn(theRuleId){
            let ruleObj = {
                ruleId: theRuleId,
                userId: this.user._id,
            }
            this.deleteSalesRule(ruleObj)
            .then((data) => {
                this.color = !data.error ? "success" : "danger",
                this.msg = data.msg
            })
            .catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['user', 'salesRules']),
        myRules() {
            if(this.salesRules && this.salesRules.length){
                return this.salesRules
            }
            return false
        },
    },
    components: {
        appGhostMode: GhostMode,
        appBreadcrumb: Breadcrumb,
        appNewSale: NewSale,
        appApplySale: ApplySale
    },
    created() {
        this.fetchSalesRules().then(() => {}).catch((e) => {})
        eventBus.$on('hideGhostMode', (value) => {
            this.applySalesRule = value;
            this.newSalesRule = value;
        }),
        this.$emit('update:layout', LayoutShop);
    }
}
</script>